import { render, staticRenderFns } from "./IrisConfirm.vue?vue&type=template&id=c45a3b06&scoped=true"
import script from "./IrisConfirm.vue?vue&type=script&lang=js"
export * from "./IrisConfirm.vue?vue&type=script&lang=js"
import style0 from "./IrisConfirm.vue?vue&type=style&index=0&id=c45a3b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45a3b06",
  null
  
)

export default component.exports